import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from './services/auth.service';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean | UrlTree> {
    const isAuth = await this.authService.isAuthenticated();
    if (!isAuth) {
      return this.router.createUrlTree(['/login']);
    }

    const user = await this.authService.getUser();
    if (user?.userType === 'admin') {
      return true;
    } else {
      return this.router.createUrlTree(['/']);
    }
  }
}
